import { atom } from "recoil";

export const elapsedTimeState = atom({
  key: 'elapsedTimeState',
  default: 0
});

export const elapsedTimeForWeatherState = atom({
  key: 'elapsedTimeForWeatherState',
  default: 0
});